export default __webpack_public_path__ + "static/media/keto_water@3x.c27bcf19.jpg";